import { MeetingMessage } from '@/twapp/objects/MeetingMessage';
import * as styles from './Message.module.less';
import { Icons, SlimButton } from "@/twapp/react/components/Buttons";

export interface IMessageProps {
    message: MeetingMessage;
    canEdit: boolean;
    onEdit: () => void;
}

function getModifiedTitle(message: MeetingMessage) {
    const ts = message.ModifiedTimestamp?.toLocaleString('sv-SE');
    const un = message.ModifiedBy?.displayName || 'okänd';
    return `${ts} av ${un}`;
}

export const Message = ({message, canEdit, onEdit}: IMessageProps) => {
    return (
        <div className={styles.container}>
            {
                !message.IsPublished && (
                    <div className={styles.hiddenBanner}>
                        Visas inte på Troman Politiker
                    </div>
                )
            }
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.subject}>{message.Subject}</div>
                    <div className={styles.message}>{message.Content}</div>
                </div>
                <div className={styles.metadata}>
                    <div>
                        {
                            message.ModifiedTimestamp && (<span className={styles.modified} title={getModifiedTitle(message)}>(ändrad)</span>)
                        }
                        <span>{message.CreatedTimestamp.toLocaleString('sv-SE')}</span>
                    </div>
                    <div className={styles.creator}>{message.CreatedBy?.displayName}</div>
                </div>
                <div className={styles.buttoncolumn}>
                    <SlimButton icon={Icons.Edit} onClick={onEdit} disabled={!canEdit} title='Redigera'/>
                </div>
            </div>
        </div>
    );
}